export class InvalidContainerChildrenError extends Error {
  constructor(node: any) {
    delete node.children;
    super(
      `Invalid container nodes. Nodes must be a layout or a widget or a collapse : ${JSON.stringify(
        node
      )}`
    );
  }
}

export class MissingComponentIdError extends Error {
  constructor(node: any) {
    delete node.children;
    super(`Missing component id : ${JSON.stringify(node)}`);
  }
}
